import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { ASSETS } from "@/data/content";

// Los enlaces del menú son anclas a SECCIONES de esta misma página. El botón
// azul es la única cosa que NAVEGA a /demo, y por eso dice una acción ("Abrir
// el tablero") y no el nombre de la sección: cuando ambos decían "Centro de
// mando" parecía que el acceso al tablero había desaparecido.
const LINKS = [
  { label: "Cómo funciona", href: "#recorrido", testid: "recorrido" },
  { label: "Centro de mando", href: "#centro-de-mando", testid: "centro-de-mando" },
  { label: "Privacidad", href: "#privacidad", testid: "privacidad" },
  { label: "Fases", href: "#fases", testid: "fases" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-slate-950/80 backdrop-blur-xl border-b border-slate-800"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-2.5 group"
        >
          <img src={ASSETS.logo} alt="Kootixli" className="h-8 w-8 object-contain" />
          <span className="font-display font-extrabold text-xl tracking-tight text-white">
            Kootixli
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.testid}`}
              className="text-sm text-slate-300 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button
            data-testid="nav-demo-btn"
            onClick={() => navigate("/demo")}
            className="inline-flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-4 py-2 rounded-md transition-colors"
          >
            Abrir el tablero <ArrowUpRight className="h-4 w-4" />
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-slate-950/95 backdrop-blur-xl border-t border-slate-800 px-6 py-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-slate-300 hover:text-white"
            >
              {l.label}
            </a>
          ))}
          <button
            data-testid="nav-demo-btn-mobile"
            onClick={() => navigate("/demo")}
            className="bg-blue-600 text-white text-sm font-medium px-4 py-2 rounded-md"
          >
            Abrir el tablero
          </button>
        </div>
      )}
    </header>
  );
}
